import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Description from "../../components/Description";
import { Wrapper, TableContainer, PaginatorContainer } from "./styled";
import ToolsPanel from "../../components/ToolsPanel";
import Table from "../../../../commons/Table";
import { FIELDS_USER_TAB, USER_PAGE_SIZE } from "../../constants";
/** Don't delete the following line! Used as property **/
import Column from "../../../../commons/Table/components/ColumnType/BackOffice/UserSection";
import Paginator from "../../../../commons/Paginator";
import {
  searchString,
  userList,
} from "../../../../../store/BackOffice/selectors";
import { exportUserList } from "../../../../../store/BackOffice/actions";
import {
  elementsCounter,
  fileFrom,
  currentPage,
} from "../../../../../store/File/selectors";
import { getPaginateUsers, getValue } from "../../functions";

const Users = (props) => {
  const dispatch = useDispatch();
  const from = useSelector(fileFrom);
  let counter = useSelector(elementsCounter);
  const elements = useSelector(userList);
  const filter = useSelector(searchString);
  const getUsersFiltered = () => {
    if (filter === null || filter === "") {
      return elements;
    } else {
      return elements.filter(
        (u) =>
          u.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
          u.profile.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
          u.mail.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
          getValue(u.disabled).toLocaleLowerCase() ===
            filter.toLocaleLowerCase(),
      );
    }
  };
  const filterElements = getUsersFiltered();
  const page = useSelector(currentPage);
  let paginateUsers = getPaginateUsers(filterElements, USER_PAGE_SIZE);

  if (!props.show) {
    return null;
  }

  return (
    <Wrapper>
      {/*<Description />*/}
      <ToolsPanel export={() => dispatch(exportUserList())} />
      <TableContainer>
        <Table
          headerItems={FIELDS_USER_TAB}
          columnsItems={paginateUsers[page]}
          columnType=<Column />
          action={getUsersFiltered}
          page={page}
        />
      </TableContainer>
      <PaginatorContainer>
        <Paginator
          left={true}
          visibility={true}
          localPagination={true}
          elements={filterElements.length}
          counter={
            filterElements.length > counter ? counter : filterElements.length
          }
          from={from}
          pages={paginateUsers?.length - 1}
          backDisabled={page <= 0}
          page={page}
          pageSize={USER_PAGE_SIZE}
        />
      </PaginatorContainer>
    </Wrapper>
  );
};

export default Users;
